(function ($) {
  var defaults = {
    "hamburgerId": "sm_menu_ham", //Hamburger Id
    "wrapperClass": "sm_menu_outer", //Menu Wrapper Class
    "submenuClass": "submenu", //Submenu Class
    "menuStyle": "slide", //Menu Style
    "onMenuLoad": function () {
      return true;
    }, //Calls when menu loaded
    "onMenuToggle": function () {
      return true;
    } //Calls when menu open/close
  };
  $.fn.simpleMobileMenu = function (options) {
    if (this.length === 0) {
      return this;
    }
    var smMenu = {},
      ds = $(this);
    var init = function () {
        smMenu.settings = $.extend({}, defaults, options);
        smMenu.styleClass = smMenu.settings.menuStyle.toLowerCase() === 'slide' ? "slide" : "accordion";
        // Create Wrapper div & hamburger
        createWrapper_Ham();
        // Create Back Menu for each sub menu
        createBackButton();
        // Callback - Menu loaded
        if (typeof smMenu.settings.onMenuLoad == 'function') {
          smMenu.settings.onMenuLoad(ds);
        }
      },
      createWrapper_Ham = function () {
        smMenu.hamburger = $("<div/>", {
          "id": smMenu.settings.hamburgerId,
          "html": "<span></span><span></span><span></span><span></span>"
        }),
          smMenu.smmOuter = $("<div/>", {"class": smMenu.settings.wrapperClass + " " + smMenu.styleClass});
        ds.appendTo(smMenu.smmOuter);
        smMenu.hamburger.add(smMenu.smmOuter).appendTo($("header"));
      },
      createBackButton = function () {
        smMenu.smmOuter.find("ul." + smMenu.settings.submenuClass).each(function () {
          var dis = $(this),
            disPar = dis.closest("li"),
            //disfA = disPar.find("> span"),
            back = "Back",
            disBack = $("<li/>", {
              "class": "back",
              "html": "<span class='empty_link'>" + back + "</span>"
            })
          disPar.addClass("has-child");

          disPar.append("<span class='ic-next'></span>");

          if (smMenu.settings.menuStyle.toLowerCase() === 'slide') {
            disBack.prependTo(dis);
          }
        });
      },
      toggleMobileMenu = function (e) {
        $("#" + smMenu.settings.hamburgerId).toggleClass("open");
        $("." + smMenu.settings.wrapperClass).toggleClass("active").find("li.active").removeClass("active");
        $("body").toggleClass("mmactive");
        if (smMenu.settings.menuStyle.toLowerCase() === 'accordion') {
          $("." + smMenu.settings.wrapperClass).find("ul." + smMenu.settings.submenuClass).hide();
        }
        // Callback - Menu Toggle
        if (typeof smMenu.settings.onMenuToggle == 'function') {
          smMenu.settings.onMenuToggle(ds, $("#" + smMenu.settings.hamburgerId).hasClass("open"));
        }
      },
      showSlideSubMenu = function (e) {
        $("body").addClass("ssubmenu");
        $("." + smMenu.settings.wrapperClass).scrollTop(0);
        $(this).parent().addClass("active").siblings().removeClass("active");
      },
      goBack = function (e) {
        e.preventDefault();
        $("body").removeClass("ssubmenu");
        $(this).closest("ul." + smMenu.settings.submenuClass).parent().removeClass("active");
      }
    /*Init*/
    init();
    /* Open Menu */
    smMenu.hamburger.on('click',toggleMobileMenu);
    /* Show Slide SubMenu */
    smMenu.smmOuter.filter(".slide").find("li.has-child > span").on('click',showSlideSubMenu);
    /* Go Back */
    smMenu.smmOuter.find("li.back span").on('click',goBack);
  };
})(jQuery);

$(document).ready(function () {
  if (window.innerWidth < 1200) {
    $(".mobile_menu").simpleMobileMenu({
      "menuStyle":"slide"
    });
  }
});

